<template>
  <div class="summary-section" ref="self">
      <img :src="images.summary" @load="emitReady">
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
export default {
    mixins: [active],
    data () {
        return {
            images: images,
            index: 1
        }
    }
}
</script>

<style>
.summary-section {
    font-size: 0;
}
</style>